import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'detectUrl',
    pure: false
})
export class detectUrlPipe implements PipeTransform {
    transform(str: any): any {
        let match = str.match(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);
        let final=str;

        match?.map(url=>{
            final=final.replace(url,"<a href=\""+url+"\" target=\"_BLANK\">"+url+"</a>")
        })
        return final;
    }
}